<template>
  <div>
    <!-- =========== End of Loader ============ -->

    <main class="main hidden">
      <!-- =========== Start of Navigation (main menu) ============ -->

      <!-- =========== End of Navigation (main menu)  ============ -->

      <!-- =========== Start of Body ============ -->
      <section
        class=" bg-color--dark--1 h-min-100vh d-flex align-items-centerv mt-4 pb-5"
      >
        <div class="svg-shape--top w-100 opacity--05">
          <img
            src="/assets/img/wave-8.svg"
            alt="wave"
            class="svg fill--white"
          />
        </div>
        <!-- end of whole area svg bg -->
        <div class="svg-shape--top opacity--10">
          <img src="assets/img/wave-9.svg" alt="wave" class="svg fill--white" />
        </div>
        <!-- end of top right mini svg shape -->

        <div class="container">
          <div class="row">
            <div
              class="col-12 mx-auto color--white text-center mb-2 mb-lg-2 pt-2"
            >
              <h3 class="mb-1 text-white">
                {{ $t("supplier.baseRegister") }}
              </h3>
            </div>
            <div class="col-12 col-sm-10 col-md-8 col-lg-7 col-xl-6 mx-auto">
              <div
                class="form--v5 px-3 py-4 px-md-5 py-md-6 rounded--10 bg-color--light--1"
              >
                <form class="form">
                  <div
                    class="alert alert-danger"
                    role="alert"
                    id="alert"
                    v-show="alert"
                  >
                    <ul>
                      <li v-for="err in errors" :key="err">
                        {{ err[0] }}
                      </li>
                    </ul>
                  </div>
                  <div class="container">
                    <!-- <div class="form-group">
                      <label
                        class="form__label text-uppercase font-size--15 font-w--500"
                        >{{ $t("register.melliCode") }}</label
                      >
                      <input
                        id="melliCode"
                        type="number"
                        @wheel="$event.target.blur()"
                        v-model.trim="$v.melli_code.$model"
                        class="form-control"
                        :class="{ 'is-invalid': $v.melli_code.$error }"
                        @blur="$v.melli_code.$touch()"
                      />

                      <div
                        class="invalid-feedback"
                        v-if="!$v.melli_code.checkMelliCode"
                      >
                        کد ملی معتبر نیست
                      </div>
                    </div> -->
                    <!-- 249418 -->

                    <div class="form-group">
                      <label
                        class="form__label text-uppercase font-size--15 font-w--500"
                        >{{ $t("register.password") }}</label
                      >
                      <input
                        id="password"
                        type="password"
                        v-model.trim="$v.password.$model"
                        class="form-control"
                        :class="{ 'is-invalid': $v.password.$error }"
                        @blur="$v.password.$touch()"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.password.required"
                      >
                        لطفا کلمه عبور را وارد کنید
                      </div>

                      <div
                        class="invalid-feedback"
                        v-if="!$v.password.minLength"
                      >
                        کلمه عبور باید حداقل شامل
                        {{ $v.password.$params.minLength.min }} کاراکتر باشد
                      </div>
                    </div>

                    <!-- REPASSWORD -->

                    <div class="form-group">
                      <label
                        class="form__label text-uppercase font-size--15 font-w--500"
                        >{{ $t("register.repassword") }}</label
                      >
                      <input
                        id="repassword"
                        type="password"
                        v-model.trim="$v.rePassword.$model"
                        :class="{ 'is-invalid': $v.rePassword.$error }"
                        class="form-control"
                        @blur="$v.rePassword.$touch()"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.rePassword.required"
                      >
                        لطفا تکرار کلمه عبور را وارد کنید
                      </div>
                      <div
                        class="invalid-feedback"
                        v-if="!$v.rePassword.sameAs"
                      >
                        تکرار رمز عبور با رمز عبور مطابق نیست
                      </div>
                    </div>

                    <!-------------- register user onformations ------------->
                  </div>

                  <div
                    class="d-flex justify-content-between align-items-center flex-column"
                  >
                    <br />
                    <br />
                    <button
                      class="btn btn-bg--primary btn-size--md btn-hover--3d"
                      type="submit"
                      @click.prevent="baseRegister"
                    >
                      <span class="btn__text">{{ $t("login.signUp") }}</span>
                    </button>
                  </div>
                </form>
                <!-- end of form -->
              </div>
              <!-- end of from area -->
            </div>
            <!-- end of col -->
          </div>
          <!-- end of row -->
        </div>
        <!-- end of container -->
      </section>
      <!-- =========== End of Body ============ -->
    </main>
  </div>
</template>

<script>
import {
  required,
  minLength,
  sameAs,
  //   maxLength,
} from "vuelidate/lib/validators";

export default {
  data() {
    return {
      alert: false,
      errors: [],
      melli_code: "",
      password: "",
      rePassword: "",
      //   //-----------------------
      //   name: "",
      //   lastName: "",
      //   fatherName: "",
      //   phone: "",
      //   province: "",
      //   city: "",
      //   address: "",
    };
  },
  beforeCreate() {
    if (this.$route.query.mobile_number == null) {
      this.$router.push("/supplier/customer-signup");
    }
  },
  methods: {
    baseRegister() {
      const baseData = {
        mobile_number: this.$route.query.mobile_number,
        melli_code: this.melli_code,
        password: this.password,
        re_password: this.rePassword,
      };

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
        this.$noty.info(this.$t("alert.alertInvalidField"));
      } else {
        let load = this.$loading.show();
        this.$store
          .dispatch("suppliersCustomerBaseRegister", baseData)
          .then((response) => {
            console.log(response);
            load.hide();
            this.$router.push("/supplier/customer-data/" + response.body.id);
          })
          .catch((err) => {
            console.log("err", err);
            this.alert = true;
            this.errors = err.body;
            load.hide();
          });
      }
    },
  },
  validations: {
   
    password: {
      minLength: minLength(6),
      required,
    },
    rePassword: {
      required,
      sameAs: sameAs("password"),
    },
  },
};
</script>

<style>
.vpd-icon-btn {
  display: flex;
  width: 1%;
  cursor: pointer;
  padding: 0 10px;
}
</style>
